import React from 'react';

import get from 'lodash/get';
import PropTypes from 'prop-types';

import Map from '@src/components/common/Availability/AvailabilityMap';
import availablityColors from '@src/components/common/Availability/AvailabilityMap/colors';

const ProductAvailabilityMap = (props) => {
    const {
        allItems,
        currentItem,
    } = props;

    const availability = [
        {
            title: 'Available',
            color: availablityColors.available,
            states: get(currentItem, 'map_available_states', []).map((s) => s.abbreviation),
        },
        {
            title: 'Not Available / Limited',
            color: availablityColors.notAvailable,
        },
    ];

    if (get(currentItem, 'map_coming_soon_states', []).length > 0) {
        availability.push({
            title: 'Coming Soon',
            color: availablityColors.comingSoon,
            states: get(currentItem, 'map_coming_soon_states', []).map((s) => s.abbreviation),
        });
    }

    if (get(currentItem, 'map_relaunched_states', []).length > 0) {
        availability.push({
            title: 'Relaunched',
            color: availablityColors.relaunched,
            states: get(currentItem, 'map_relaunched_states', []).map((s) => s.abbreviation),
        });
    }

    return (
        <Map availability={availability} allItems={allItems} currentItem={currentItem} />
    );
};

ProductAvailabilityMap.propTypes = {
    allItems: PropTypes.arrayOf(PropTypes.object),
    currentItem: PropTypes.shape({
        platform: PropTypes.string,
        map_available_states: PropTypes.arrayOf(PropTypes.shape({
            abbreviation: PropTypes.string.isRequired,
        })),
        map_coming_soon_states: PropTypes.arrayOf(PropTypes.shape({
            abbreviation: PropTypes.string.isRequired,
        })),
        map_relaunched_states: PropTypes.arrayOf(PropTypes.shape({
            abbreviation: PropTypes.string.isRequired,
        })),
    }),
};

export default React.memo(ProductAvailabilityMap);
